module.exports = __webpack_public_path__ + "static/media/OrderAheadEmptyIcon.ebe2df8b.png";